import React from 'react';
import Icon from '../../../components/AppIcon';

const ContentTypeChart = () => {
  const contentTypes = [
    {
      id: 1,
      type: 'Code Snippets',
      posts: 18,
      avgEngagement: 14.2,
      avgReach: 3200,
      icon: 'Code',
      color: 'var(--color-primary)',
      performance: 'excellent'
    },
    {
      id: 2,
      type: 'Technical Articles',
      posts: 12,
      avgEngagement: 11.8,
      avgReach: 2800,
      icon: 'FileText',
      color: 'var(--color-success)',
      performance: 'good'
    },
    {
      id: 3,
      type: 'Quick Tips',
      posts: 24,
      avgEngagement: 9.5,
      avgReach: 2100,
      icon: 'Lightbulb',
      color: 'var(--color-accent)',
      performance: 'good'
    },
    {
      id: 4,
      type: 'Industry News',
      posts: 8,
      avgEngagement: 7.2,
      avgReach: 1600,
      icon: 'Newspaper',
      color: 'var(--color-warning)',
      performance: 'average'
    },
    {
      id: 5,
      type: 'Personal Updates',
      posts: 6,
      avgEngagement: 5.8,
      avgReach: 1200,
      icon: 'User',
      color: 'var(--color-muted-foreground)',
      performance: 'average'
    }
  ];

  const maxEngagement = Math.max(...contentTypes?.map(ct => ct?.avgEngagement));

  const getPerformanceBadge = (performance) => {
    if (performance === 'excellent') {
      return 'bg-success/20 text-success';
    }
    if (performance === 'good') {
      return 'bg-primary/20 text-primary';
    }
    return 'bg-muted text-muted-foreground';
  };

  return (
    <div className="space-y-4">
      {contentTypes?.map((content) => (
        <div key={content?.id} className="space-y-2">
          {/* Content Type Header */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div
                className="w-8 h-8 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: `${content?.color}20` }}
              >
                <Icon name={content?.icon} size={16} color={content?.color} />
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground">{content?.type}</h4>
                <p className="text-xs text-muted-foreground">{content?.posts} posts</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-sm font-bold text-foreground">{content?.avgEngagement}%</p>
              <span className={`text-xs px-2 py-0.5 rounded-full ${getPerformanceBadge(content?.performance)}`}>
                {content?.performance}
              </span>
            </div>
          </div>

          {/* Engagement Bar */}
          <div className="relative w-full h-2 bg-muted rounded-full overflow-hidden">
            <div
              className="absolute left-0 top-0 h-full rounded-full transition-all duration-500"
              style={{
                width: `${(content?.avgEngagement / maxEngagement) * 100}%`,
                backgroundColor: content?.color
              }}
            ></div>
          </div>

          {/* Stats */}
          <div className="flex items-center justify-between text-xs text-muted-foreground">
            <span>Avg Reach: {(content?.avgReach / 1000)?.toFixed(1)}k</span>
            <span>Engagement Rate: {content?.avgEngagement}%</span>
          </div>
        </div>
      ))}

      {/* Insights */}
      <div className="mt-6 pt-4 border-t border-border">
        <div className="bg-accent/10 rounded-lg p-3 border border-accent/20">
          <div className="flex items-start gap-2">
            <Icon name="TrendingUp" size={16} color="var(--color-accent)" className="mt-0.5" />
            <div>
              <p className="text-sm font-semibold text-foreground mb-1">Content Strategy Insight</p>
              <p className="text-xs text-muted-foreground">
                Code snippets and technical articles perform 2.5x better than other content types.
                Focus on creating more technical deep-dives with practical examples.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentTypeChart;